import React from 'react';
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined';
import { handleInput } from '../../triwordUtils';
import { SpecialKeys } from '../../../shared/utils';
import { TriwordStore } from '../../TriwordStore';
import { AppStore } from '../../../../../AppStore';

type KeyProps = {
  value: string;
};

const Key = ({ value }: KeyProps) => {
  const { lettersFor5050, used5050Lifeline } = TriwordStore.useState();
  const hapticFeedbackEnabled = AppStore.useState(s => s.userData?.settings.hapticFeedbackEnabled) ?? true;

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    if (hapticFeedbackEnabled) {
      try {
        navigator.vibrate(20)
      } catch (error) {
        // do nothing, just don't vibrate
      }
    }
    handleInput(value);
    event.currentTarget.blur()
  };

  const isWideKey = value === SpecialKeys.Enter || value === SpecialKeys.Delete;

  const getSymbol = (value: string) => {
    if (value === SpecialKeys.Delete) {
      return <BackspaceOutlinedIcon/>;
    } else {
      return value;
    }
  };

  const isDisabled = used5050Lifeline && lettersFor5050.includes(value.toLowerCase());

  return (
    <button
      disabled={isDisabled}
      className={`${isWideKey ? 'wideKey' : ''} ${isDisabled ? 'faded' : ''} keyboardKey`}
      onClick={handleClick}
    >
      {getSymbol(value)}
    </button>
  )
};

export default Key;